"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopOutMenu = exports.PopOutMenuArrowSide = exports.TEST_ID_POP_OUT_MENU = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var positioningProperties_1 = require("./positioningProperties");
exports.TEST_ID_POP_OUT_MENU = "popoutmenu";
var positioningProperties_2 = require("./positioningProperties");
Object.defineProperty(exports, "PopOutMenuArrowSide", { enumerable: true, get: function () { return positioningProperties_2.PopOutMenuArrowSide; } });
function PopOutMenu(_a) {
    var children = _a.children, _b = _a.arrowSide, arrowSide = _b === void 0 ? positioningProperties_1.PopOutMenuArrowSide.NONE : _b, _c = _a.arrowPosition, arrowPosition = _c === void 0 ? "50%" : _c, csx = _a.csx;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: __assign({ bg: theme_1.theme.colors.offBlack, p: 4, position: "absolute", "::before": __assign(__assign({}, positioningProperties_1.getPositionProperty(arrowSide, arrowPosition)), { background: theme_1.theme.colors.offBlack, clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)", content: "''", flexDirection: "column", height: 3, position: "absolute", width: 3 }) }, csx), "data-testid": exports.TEST_ID_POP_OUT_MENU }, children));
}
exports.PopOutMenu = PopOutMenu;
